import {
    IMachineHealthNotificationTriggerRequestChild,
    MachineHealthNotificationSubscriptionResponse,
    MachineHealthNotificationSubscriptionUpdateRequest,
    MachineHealthNotificationTriggerRequestChild,
} from '@kcftech/prometheustypescriptapiclient';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

/**
 * Configuration object for editing machine health notification subscriptions.
 */
export type EditMachineHealthNotificationSubscription = Readonly<{
    /**
     * Id of the notification subscription to edit.
     */
    id: string;
    /**
     * Whether or not this notification should be silenced. Defaults to `false`.
     */
    isSilenced?: boolean;
    /**
     * The types of events that will trigger notifications for this subscription.
     */
    triggers: IMachineHealthNotificationTriggerRequestChild[];
}>;

export function editMachineHealthNotificationSubscription({
    id,
    isSilenced = false,
    triggers,
}: EditMachineHealthNotificationSubscription) {
    return sdClient.updateMachineHealthNotificationSubscription({
        subscriptionId: id,
        body: new MachineHealthNotificationSubscriptionUpdateRequest({
            IsSilenced: isSilenced,
            NotificationTriggers: triggers.map(
                (trigger) => new MachineHealthNotificationTriggerRequestChild(trigger)
            ),
        }),
    });
}

/** Type of data returned by mutation function */
type Data = MachineHealthNotificationSubscriptionResponse;

/** The mutation options object type */
type Options = UseMutationOptions<
    Data,
    unknown,
    EditMachineHealthNotificationSubscription
>;

export function useEditMachineHealthNotificationSubscription(options: Options) {
    return useMutation<Data, unknown, EditMachineHealthNotificationSubscription>({
        mutationFn: (args) => editMachineHealthNotificationSubscription(args),
        ...options,
    });
}
